import { render, staticRenderFns } from "./ProfilePurse.vue?vue&type=template&id=b54e78f0&scoped=true&"
import script from "./ProfilePurse.js?vue&type=script&lang=js&"
export * from "./ProfilePurse.js?vue&type=script&lang=js&"
import style0 from "./ProfilePurse.scss?vue&type=style&index=0&id=b54e78f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54e78f0",
  null
  
)

export default component.exports